import { render, staticRenderFns } from "./DescriptionEntityType.vue?vue&type=template&id=40fcf4b0"
import script from "./DescriptionEntityType.vue?vue&type=script&lang=js"
export * from "./DescriptionEntityType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports